__turbopack_context__.v({
  "blurred": "AspectRatioImageCard-module-scss-module__w-BPCG__blurred",
  "image": "AspectRatioImageCard-module-scss-module__w-BPCG__image",
  "linkOrClick": "AspectRatioImageCard-module-scss-module__w-BPCG__linkOrClick",
  "top": "AspectRatioImageCard-module-scss-module__w-BPCG__top",
});
